import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from "react-router-dom";
import Stepper from '../Stepper';
import PricingCards from '../Pricing';
import Contact from '../Contact';
import RetailAvailability from '../RetailAvailibilty';
import ClinicalStudies from '../Studies';
import Footer from '../Footer';
import Banner from '../Banner';

function PMCampaign() {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
    const [startTimer, setStartTimer] = useState(false);
      const pricingRef = useRef(null);
    
  
  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);
      const videoParam = params.get("v");
      setIsVideoParamExists(videoParam === "y");
      setIsShowVsl(1);
    }
  }, [location]);
  useEffect(() => {
    const SECONDS_TO_DISPLAY = 20; // Set the time in seconds after which the element will appear
    let attempts = 0;
    let elsDisplayed = false;

    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

    const showHiddenElements = () => {
      elsDisplayed = true;
      setIsVisible(true); // Show content after the delay time
      localStorage.setItem(alreadyDisplayedKey, true);
    };

    const startWatchVideoProgress = () => {
      // Wait for smartplayer to be available
      if (typeof window.smartplayer === 'undefined' || !(window.smartplayer.instances && window.smartplayer.instances.length)) {
        if (attempts >= 10) return; // Stop after 10 attempts to find the player
        attempts += 1;
        return setTimeout(() => { startWatchVideoProgress(); }, 1000); // Retry after 1 second
      }

      const player = window.smartplayer.instances[0];

      // Listen for the video's time update to sync the delay
      player.on('timeupdate', () => {
        if (elsDisplayed || player.smartAutoPlay) return;
        if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
        showHiddenElements(); // Show the elements after the defined time
      });
    };

    if (alreadyElsDisplayed === 'true') {
      setTimeout(() => { showHiddenElements(); }, 100); // Immediate display if already displayed
    } else {
      startWatchVideoProgress(); // Start watching the video progress for the delay
    }

  }, []);

    useEffect(() => {
      if (isVisible && pricingRef.current) {
        pricingRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, [isVisible]);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setIsVisible(true);
        },
        { threshold: 0.1 }
      );
  
      if (pricingRef.current) observer.observe(pricingRef.current);
  
      return () => observer.disconnect();
    }, []);
  
    useEffect(() => {
      if (isVisible && !startTimer) {
        setStartTimer(true); // Trigger timer when visible
      }
    }, [isVisible, startTimer]);
  return (
    <>
      {isVideoParamExists !== null && (
        <div className="w-full">
          {isVideoParamExists ? (
            <>
              {/* vsl page */}
              <div className=''>
                {/* <div className=" p-3 bg-center  bg-[url('https://sinoclear.net/pm/images/down-sec1.jpg')] bg-no-repeat h-32 text-center flex flex-col items-center justify-center" >
                  <h3 className="md:text-2xl text-lg text-[#fdf651] font-medium ">
                    IMPORTANT: Do NOT close this window nor click the “Back” button


                  </h3>
                  <p className='text-[#fdf651] md:text-xl text-base'>
                    Clicking “back” button can result in your order being double-billed


                  </p>
                </div> */}
                <div className='max-w-7xl mx-auto'>

                  <div className=" p-3 max-w-7xl text-center flex flex-col items-center justify-center" >
                    <p className="md:text-4xl text-xl max-w-3xl !text-[#FF0000] font-semibold " style={{ color: "#FF0000", fontSize: "32px", fontWeight: 700, lineHeight: "normalb" }}>
                      "Watch This Now To Discover How To Accelerate <br></br>Your Results With SinoClear"


                    </p>
                  </div>

                  {/* //   Dynamically embed the player script */}
                  <div className='w-full flex items-center justify-center'>
                    <div
                      className='w-2/3'
                      dangerouslySetInnerHTML={{
                        __html: `<script type="text/javascript" id="scr_677d54bf4e05c0518227c3d5"></script>`,
                      }}

                    />

                    {/* Helmet to inject the video player script into the head */}
                    <Helmet>
                      <script type="text/javascript">
                        {`
            var s = document.createElement("script");
            s.src = "https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/677d54bf4e05c0518227c3d5/player.js";
            s.async = true;
            document.head.appendChild(s);
          `}
                      </script>
                    </Helmet>
                  </div>




                  <div id="smartplayer" style={{
                    width: '100%',
                    position: 'relative',
                    padding: '0', // Overrides the padding
                  }}></div>

                  {/* <div className=" pt-10 p-3 max-w-7xl text-center flex flex-col items-center justify-center" >
                    <h3 className="md:text-lg text-sm max-w-3xl text-gray-700 font-semibold ">
                      <strong className='text-red-600'>
                        DO THIS FIRST:
                      </strong>   Please watch this important New Member update right now. Your order and access link to your bonuses will appear here at the end of the video.



                    </h3>
                  </div> */}
                </div>


              </div>
              {isVisible &&
                <div class="hide smartplayer-scroll-event" id="hidden-section">
                  {/* <Stepper /> */}
                  <div ref={pricingRef}>
                    <PricingCards startTimer={startTimer} />
                  </div>                    {/* <Contact /> */}
                  <RetailAvailability />
                </div>}
              <ClinicalStudies />
              <Footer />
            </>
          ) : (
            <>
              {/* simple page  */}
              <Banner />
              <Stepper />
              <PricingCards startTimer={startTimer} />
              <Contact />
              <RetailAvailability />
              <ClinicalStudies />
              <Footer />
            </>
          )}
        </div>
      )}
    </>
  );
}

export default PMCampaign;
